import styled, { css } from "styled-components";

const getColor = (type, customColor) => {
    if (customColor) return customColor;
    
    switch(type) {
      case 'primary':
        return 'var(--theme-color-primary)';
      case 'secondary':
        return 'var(--theme-color-forth)';
      case 'success':
        return 'var(--color-success)';
      case 'error':
        return 'var(--color-error)';
      case 'warning':
        return 'var(--color-warning)';
      case 'light':
        return 'var(--color-default)';
      default:
        return 'var(--theme-color-primary)';
    }
  };
  
export const TabContainer = styled.div`
    width: 100%;
    ${props => props.$heightfull ? css`
      height: 100%;
      overflow: hidden;
    ` : css`
      gap: 20px;
    `}
    display: flex;
    flex-direction: column;
`;
  
export const TabList = styled.div`
    background-color: ${props => props.$bgColor};
    display: flex;
    border-bottom: 1px solid var(--border-color-secondary);

    ${props => props.centered && `
      justify-content: center;
    `}
    
    @media only screen and (max-width: 768px) {
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      width: 100%;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: thin;
      scrollbar-color: var(--theme-color-tertiary) transparent;
      
      &::-webkit-scrollbar {
        height: 4px;
      }
      
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background: var(--theme-color-tertiary);
        border-radius: 4px;
      }
    }
  `;
  
export const TabButton = styled.div`
    padding: 10px 20px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.$active ? getColor(props.color, props.customcolor) : 'var(--text-color-primary)'};
    opacity: ${props => props.disabled ? 0.5 : 1};
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    border-bottom: 2px solid ${props => props.$active ? getColor(props.color, props.customcolor) : 'transparent'};
    transition: all 0.3s ease;
    min-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    @media only screen and (max-width: 768px) {
      flex-shrink: 0;
      white-space: nowrap;
    }
  
    &:hover {
      /* background: var(--theme-color-tertiary); */
    }
  
    svg {
      width: 20px;
      height: 20px;
      color: ${props => props.$active ? getColor(props.color, props.customcolor) : 'var(--text-color-secondary)'};
    }
  `;

  export const CountContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--theme-color-primary);
    border-radius: 12px;
    padding: 2px 5px;
    font-size: 10px;
    color: var(--theme-color-white);
    opacity: 0.8;
  `;

export const TabContent = styled.div`
  width: 100%;
  color: var(--text-color-primary);
  ${props => props.$heightfull && css`
    flex: 1;
    overflow: auto;
  `}
`;